import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { createLogger } from "@ict/shared";

const logger = createLogger({ module: "browser" });

/** 네이티브/웹 환경에 맞게 외부 URL을 브라우저로 열기 */
export async function openExternalUrl(url: string): Promise<void> {
  try {
    if (Capacitor.isNativePlatform()) {
      await Browser.open({ url, presentationStyle: "popover" });
    } else {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  } catch (err) {
    logger.error("외부 브라우저 열기 실패:", err);
  }
}
